import { Routes, Route, Navigate, useParams } from 'react-router-dom';
import { AuthProvider } from '@/context/AuthContext';
import { ConfigProvider } from '@/context/ConfigContext';
import { TaleemXBootSplash } from '@/components/brand';
import LoginPage from '@/pages/Login';
import AdminDashboard from '@/pages/admin/AdminDashboard';
import AdminStudentsPage from '@/pages/admin/AdminStudents';
import AdminClassTransferPage from '@/pages/admin/AdminClassTransfer';
import AdminTeachersPage from '@/pages/admin/AdminTeachers';
import AdminAttendancePage from '@/pages/admin/AdminAttendance';
import AdminTeacherAttendancePage from '@/pages/admin/AdminTeacherAttendance';
import AdminReportsStudentsPage from '@/pages/admin/AdminReportsStudents';
import AdminReportsTeachersPage from '@/pages/admin/AdminReportsTeachers';
import AdminStudentPersonReportPage from '@/pages/admin/AdminStudentPersonReport';
import AdminTeacherPersonReportPage from '@/pages/admin/AdminTeacherPersonReport';
import AdminAttendanceSchoolPage from '@/pages/admin/AdminAttendanceSchool';
import AdminAttendanceClassPage from '@/pages/admin/AdminAttendanceClass';
import AdminVacations from '@/pages/admin/AdminVacations';
import AdminSchoolStructurePage from '@/pages/admin/AdminSchoolStructure';
import TeacherDashboardPage from '@/pages/teacher/TeacherDashboard';
import TeacherHistoryPage from '@/pages/teacher/TeacherHistory';
import TeacherStudentsPage from '@/pages/teacher/TeacherStudents';
import TeacherProfilePage from '@/pages/teacher/TeacherProfile';

import { ProtectedRoute } from '@/routes/ProtectedRoute';

function RedirectStudentReport() {
  const { studentId } = useParams();
  return <Navigate to={`/admin/reports/students/${studentId}`} replace />;
}

export default function App() {
  return (
    <ConfigProvider>
      <AuthProvider>
        <TaleemXBootSplash />
        <Routes>
          <Route path="/login" element={<LoginPage />} />


          <Route element={<ProtectedRoute allow={['admin', 'ADMIN']} />}>
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="/admin/classes" element={<Navigate to="/admin/settings/school-structure" replace />} />
            <Route path="/admin/students/class-transfer" element={<AdminClassTransferPage />} />
            <Route path="/admin/students" element={<AdminStudentsPage />} />
            <Route path="/admin/teachers/class-promotion" element={<Navigate to="/admin/teachers" replace />} />
            <Route path="/admin/teachers" element={<AdminTeachersPage />} />
            <Route path="/admin/leaderboard" element={<Navigate to="/admin/attendance/students" replace />} />
            {/* Attendance routes */}

            {/* Records routes */}
            <Route path="/admin/records" element={<Navigate to="/admin/students" replace />} />
            <Route path="/admin/records/students" element={<Navigate to="/admin/students" replace />} />
            <Route path="/admin/records/teachers" element={<Navigate to="/admin/teachers" replace />} />

            {/* Settings Routes */}
            <Route path="/admin/settings" element={<Navigate to="holidays" replace />} />
            <Route path="/admin/settings/holidays" element={<AdminVacations />} />
            <Route path="/admin/settings/school-structure" element={<AdminSchoolStructurePage />} />

            {/* Reports Routes */}
            <Route path="/admin/reports/students/:studentId" element={<AdminStudentPersonReportPage />} />
            <Route path="/admin/reports/students" element={<AdminReportsStudentsPage />} />
            <Route path="/admin/reports/teachers/:teacherId" element={<AdminTeacherPersonReportPage />} />
            <Route path="/admin/reports/teachers" element={<AdminReportsTeachersPage />} />

            {/* Attendance Routes */}
            {/* Attendance Routes */}
            <Route path="/admin/attendance" element={<Navigate to="students" replace />} />
            <Route path="/admin/attendance/students" element={<AdminAttendancePage />} />
            <Route path="/admin/attendance/teachers" element={<AdminTeacherAttendancePage />} />
            {/* New Routes (Hidden from Sidebar) */}
            <Route path="/admin/attendance/school" element={<AdminAttendanceSchoolPage />} />
            <Route path="/admin/attendance/class" element={<AdminAttendanceClassPage />} />
            <Route path="/admin/attendance/student/:studentId" element={<RedirectStudentReport />} />
            <Route path="/admin/*" element={<Navigate to="/admin" replace />} />
          </Route>

          <Route element={<ProtectedRoute allow={['teacher', 'TEACHER']} />}>
            <Route path="/teacher" element={<TeacherDashboardPage />} />
            <Route path="/teacher/history" element={<TeacherHistoryPage />} />
            <Route path="/teacher/students" element={<TeacherStudentsPage />} />
            <Route path="/teacher/class-promotion" element={<Navigate to="/teacher/students" replace />} />
            <Route path="/teacher/profile" element={<TeacherProfilePage />} />
            <Route path="/teacher/*" element={<Navigate to="/teacher" replace />} />
          </Route>

          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </AuthProvider>
    </ConfigProvider>
  );
}
